import fetchival from 'fetchival';
import config from '../../config/config';

const Subscriptions = fetchival(config.API_BASE_URL + '/subscriptions');

class SubscriptionsApi {
  static create(email) {
    return Subscriptions.post({email});
  }
}

export default SubscriptionsApi;



// WEBPACK FOOTER //
// ./src/api/subscriptions/subscriptionsApi.js